import styled from "styled-components";
import { detailActionButtonCss } from "../../../../app/shared/orderDesign/detailActionButtonCss";
import { DetailPageTopBarRight } from "./Right";

/** Top-bar action cluster matching order detail outline buttons (Clone, Activity Log). */
export const DetailActionTopBarRight = styled(DetailPageTopBarRight)`
  align-items: center;
  gap: 8px;

  button {
    ${detailActionButtonCss}
    transition:
      background-color 0.15s ease,
      border-color 0.15s ease,
      color 0.15s ease;
  }
`;
